import React, { useMemo } from "react";
import { constraints, datatypes, inputTypes } from "data/globalData";
import SelectInputField from "../InputComponents/SelectInputField";
import TextInputField from "../InputComponents/TextInputField";
import { grey } from "@mui/material/colors";
import { constraintsOptions } from "components/PimDashboard/data";

const RenderInputField = React.memo(
	({
		column,
		setData,
		data,
		width = "30%",
		longWidth = "60%",
		selectOptObjName,
		dependencyColData,
		multiple,
		onChangeCallBack,
		error = false,
		onBlur,
		...rest
	}) => {
		const options = column[selectOptObjName] ? column[selectOptObjName] : { type: "objType", list: {} };

		const sx = {
			display: "flex",
			alignItems: "center",
		};
		const inputSx = {
			width: "60%",
			flex: 1, // p: 1,
			background: column?.input_type === inputTypes.AUTO_GENERATE.key ? grey[300] : grey[100],
			fontWeight: 400,
			overflow: "hidden",
			boxSizing: "border-box",
			borderRadius: "0px 6px 6px 0px",
			"& .MuiOutlinedInput-root": {
				borderRadius: "0px 6px 6px 0px",

				"& fieldset": {
					borderLeft: "none",
				},

				"&:hover fieldset": {
					borderLeft: "none",
				},

				"&.Mui-focused fieldset": {
					borderLeft: "none",
				},
			},
		};
		const labelSx = {
			maxWidth: "38%",
			minWidth: "25%",
			borderRadius: "6px 0px 0px 6px",
			p: 1,
			background: "#000",
			color: grey[50],
		};

		const updateValue = (e, value) => {
			setData((prev) => {
				const updated = { ...prev, [column.key]: value };

				if (typeof dependencyColData === "object") {
					Object.keys(dependencyColData)?.forEach((element) => {
						if (column.key === element) {
							updated[dependencyColData[element].col.key] = dependencyColData[element].val(
								element,
								value,
								dependencyColData[element].col.key,
								options,
							);
						}
					});
				}

				if (typeof onChangeCallBack === "function") {
					onChangeCallBack(e, value, updated);
				}

				return updated;
			});
		};

		const handleChange = (e) => {
			const rawValue = e.target.value;
			const value = typeof rawValue === "string" ? rawValue.trimStart() : rawValue;

			updateValue(e, value);
		};

		const handleBlur = (e) => {
			const rawValue = e.target.value;

			if (typeof rawValue === "string") {
				updateValue(e, rawValue.trim());
			}

			if (typeof onBlur === "function") {
				onBlur(e);
			}
		};

		if (!column) return null;

		if (column.input_type === inputTypes.ENTER.key || column.input_type === inputTypes.AUTO_GENERATE.key) {
			return (
				<TextInputField
					sx={sx}
					inputSx={inputSx}
					labelSx={labelSx}
					error={error}
					data={data}
					disabled={column?.input_type === inputTypes.AUTO_GENERATE.key}
					setData={setData}
					onChange={handleChange}
					onBlur={handleBlur}
					column={column}
					width={
						column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
							? longWidth
							: width
					}
					required={!!column?.constraints[constraintsOptions.NOTNULL.key]}
					type={column?.data_type}
					InputProps={{ sx: { borderRadius: "0px 2px 2px 0px" } }}
					{...rest}
				/>
			);
		}

		return (
			<SelectInputField
				sx={sx}
				inputSx={inputSx}
				labelSx={labelSx}
				data={data}
				setData={setData}
				column={column}
				width={
					column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
						? longWidth
						: width
				}
				onChange={handleChange}
				onBlur={onBlur}
				options={options}
				required={!!column?.constraints[constraintsOptions.NOTNULL.key]}
				disabled={column?.input_type === inputTypes.AUTO_GENERATE.key}
				multiple={multiple || column?.input_type === inputTypes.MULTIPLE_SELECT.key}
				error={error}
				{...rest}
			/>
		);
	},
);

export default RenderInputField;
